import * as actionTypes from "./actionTypes";
import vediApi from "../../utils/vedi-api/vediAPI";

export const setCuilValidado = (validado) => ({
  type: actionTypes.SET_VALIDACION_CUIL,
  validado,
});

export const setPersona = (persona) => ({
  type: actionTypes.SET_PERSONA,
  persona,
});

export const setRelaciones = (relaciones) => ({
  type: actionTypes.SET_RELACIONES,
  listaRepresentados: relaciones.listaRepresentados,
  listaRepresentantes: relaciones.listaRepresentantes,
  listaRepresentadosLegales: relaciones.listaRepresentadosLegales,
});

export const setRelacionesFailed = (error) => ({
  type: actionTypes.SET_RELACIONES_FAILED,
  error,
});

export const setListaTerceros = () => ({
  type: actionTypes.SET_LISTA_TERCEROS,
});

export const updateRelaciones = () => ({
  type: actionTypes.UPDATE_RELACIONES,
});

export const setRepresentadosPorApp = (representadosPorApp) => ({
  type: actionTypes.SET_REPRESENTADOS_POR_APP,
  representadosPorApp,
});

export const setCarpetaRepresentadoSelected = (
  carpetaRepresentadoSelected
) => ({
  type: actionTypes.SET_CARPETA_REPRESENTADO_SELECCIONADO,
  carpetaRepresentadoSelected,
});

const setErrorUpdateRdosLegales = () => ({
  type: actionTypes.SET_ERROR_UPDATE_RDOS_LEGALES,
});

export const getNivelCIDI = (cuil) => {
  return (dispatch) =>
    vediApi
      .get(`/v1/nivelcidi?cuil=${cuil}`)
      .then((res) => {
        if (!res || !res.data || !res.data.ok) {
          return -1;
        }
        dispatch(setPersona(res.data.return));
        return res.data.return.nivel;
      })
      .catch((error) => {
        if (error.response) {
          return -1;
        } else {
          throw Error();
        }
      });
};

export const getServiciosRelacionables = (
  idRepresentado,
  idRepresentante,
  idAutorizante,
  accion
) => {
  return vediApi
    .get(
      `/v1/RepresentacionesLegales/AplicacionesPosibles?IdRepresentado=${idRepresentado}&IdRepresentante=${idRepresentante}&IdAutorizante=${idAutorizante}&Accion=${accion}`
    )
    .then(({ data }) => {
      if (!data.ok) {
        throw Error(data.error);
      }
      return data.return;
    })
    .catch(() => {
      return [];
    });
};

export const crearRelacion = (body) => {
  return (dispatch) =>
    vediApi
      .post("/v1/RepresentacionesLegales/Relaciones", body)
      .then(({ data }) => {
        if (!data.ok) {
          throw Error(data.error);
        }
        return { exito: true, mensaje: data.return };
      })
      .catch((error) => {
        return { exito: false, mensaje: error.message };
      });
};

export const getRelationsApi = async (approvedServices = false) => {
  const { data } = await vediApi.get(
    `/v1/RepresentacionesLegales/Relaciones?serviciosAprobados=${approvedServices}`
  );

  if (!data.ok) throw new Error(data.error);

  return data.return;
};

export const getRelaciones = (serviciosAprobados = false) => {
  return (dispatch) =>
    vediApi
      .get(
        `/v1/RepresentacionesLegales/Relaciones?serviciosAprobados=${serviciosAprobados}`
      )
      .then(({ data }) => {
        if (!data.ok) {
          throw Error(data.error);
        }

        dispatch(setRelaciones(data.return));
        if (!serviciosAprobados) {
          dispatch(setListaTerceros());
        }
      })
      .catch((error) => {
        setRelacionesFailed(error);
      });
};

export const actualizarRelacion = (id, estadoNuevo) => {
  return (dispatch) =>
    vediApi
      .put("/v1/RepresentacionesLegales/Relaciones/ActualizarEstado", {
        id,
        estadoNuevo,
      })
      .then(({ data }) => {
        if (!data.ok) {
          throw Error(data.error);
        }
        dispatch(updateRelaciones());
      });
};

export const getRepresentadosPorApp = (idAplicacion) => {
  return (dispatch) =>
    vediApi
      .get(`/v1/DatosAplicacion?idAplicacion=${idAplicacion}`)
      .then(({ data }) => {
        if (!data.ok) {
          throw Error(data.error);
        }
        dispatch(setRepresentadosPorApp(data.return.representados));
        return data.return;
      })
      .catch((error) => {
        console.error("Error trayendo representados", error);
      });
};

export const setRepresentadoApp = (cuilRepresentado, idAplicacion) => {
  return (dispatch) =>
    vediApi
      .post("/v1/SeleccionarRepresentadoAplicacion", {
        cuilRepresentado,
        idAplicacion,
      })
      .then(({ data }) => {
        if (!data.ok) {
          throw Error(data.error);
        }
        return data.return;
      })
      .catch((error) => {
        console.error("Error creando representado", error);
      });
};

export const actualizarRdosLegalesCiDiVedi = (retries = 3) => {
  return (dispatch) =>
    vediApi
      .put("/v1/usuario/ActualizarRdosLegalesCiDiVedi", {})
      .then(({ data }) => {
        if (!data.ok) {
          throw Error(data.error);
        }
        return data.return;
      })
      .catch((e) => {
        if (retries > 0) {
          dispatch(actualizarRdosLegalesCiDiVedi(retries - 1));
        } else {
          console.error("Error actualizando representado", e);
          dispatch(setErrorUpdateRdosLegales());
        }
      });
};
